// packages/frontend/src/components/Turnstile.tsx
import { Turnstile, TurnstileInstance } from '@marsidev/react-turnstile'
import { useRef, forwardRef, useImperativeHandle } from 'react'

export interface TurnstileRef {
  reset: () => void
  getToken: () => string | undefined
}

interface TurnstileComponentProps {
  onVerify: (token: string) => void
  onError?: (error: any) => void
  onExpire?: () => void
  theme?: 'light' | 'dark' | 'auto'
  size?: 'normal' | 'compact'
  action?: string
}

export const TurnstileComponent = forwardRef<TurnstileRef, TurnstileComponentProps>(
  ({ onVerify, onError, onExpire, theme = 'dark', size = 'normal', action = 'login' }, ref) => {
    const turnstileRef = useRef<TurnstileInstance>(null)

    useImperativeHandle(ref, () => ({
      reset: () => {
        turnstileRef.current?.reset()
      },
      getToken: () => {
        return turnstileRef.current?.getResponse()
      }
    }))

    return (
      <Turnstile
        ref={turnstileRef}
        siteKey={import.meta.env.VITE_TURNSTILE_SITE_KEY || '0x4AAAAAAB9T48niazaz04XY'}
        onSuccess={onVerify}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme,
          size,
          action,
          appearance: 'always',
          retry: 'auto',
        }}
      />
    )
  }
)

TurnstileComponent.displayName = 'TurnstileComponent'